import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sidebarOpen: true,
    isMobileMenuOpen: false,
    theme: 'light',
    notifications: [],
    loading: false,
    modal: {
        isOpen: false,
        type: null,
        data: null,
    },
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        addNotification: (state, action) => {
            state.notifications.push(action.payload);
        },
        removeNotification: (state, action) => {
            state.notifications = state.notifications.filter(
                (notification) => notification.id !== action.payload
            );
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        openModal: (state, action) => {
            state.modal.isOpen = true;
            state.modal.type = action.payload.type;
            state.modal.data = action.payload.data;
        },
        closeModal: (state) => {
            state.modal.isOpen = false;
            state.modal.type = null;
            state.modal.data = null;
        },
        toggleMobileMenu: (state) => {
            state.isMobileMenuOpen = !state.isMobileMenuOpen;
        },
        closeMobileMenu: (state) => {
            state.isMobileMenuOpen = false;
        },
    },
});

export const {
    toggleSidebar,
    setTheme,
    addNotification,
    removeNotification,
    setLoading,
    openModal,
    closeModal,
    toggleMobileMenu,
    closeMobileMenu,
} = uiSlice.actions;

export default uiSlice.reducer;